var _rect, _path, _path2, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUndefined = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 36,
  x: 9,
  y: 2,
  fill: "#EBEBEB",
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C8C8C8",
  d: "M9 29h30v7a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDD",
  d: "M30 29V2h7a2 2 0 0 1 2 2v25z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 19.5,
  x: 1,
  y: 11,
  fill: "#303030",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.03 23.38v1.37h-1.17v-1.37zm-1.14-.98q0-.27.07-.49.08-.23.2-.41a4 4 0 0 1 .28-.36 16 16 0 0 1 .33-.34l.29-.29a2.2 2.2 0 0 0 .34-.44 1.2 1.2 0 0 0 .14-.61q0-.48-.27-.74-.26-.27-.74-.27-.59 0-.89.27-.3.26-.44.86l-1.05-.14a2.8 2.8 0 0 1 .24-.74q.17-.36.45-.63.29-.27.7-.42a2.8 2.8 0 0 1 1-.16q1.04 0 1.61.51.57.5.57 1.32 0 .48-.15.81a2 2 0 0 1-.35.56l-.61.61a3 3 0 0 0-.43.53 1.14 1.14 0 0 0-.17.62v.15h-1.12z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUndefined);
export default ForwardRef;